import { t } from 'i18next';
import * as yup from 'yup';

import { AutocompleteFieldOption } from '~components/FormFields/v2/Autocomplete/types';
import { CompanyBasic } from '~hooks/useCompany/models';
import { ServiceClass } from '~hooks/useServiceClass/models';
import UserStore from '~store/UserStore';
import { DEFAULT_PALETTE_COLOR, hexColorYupField } from '~utils/colors';

export const serviceClassSchema = yup.object().shape({
  company: yup
    .object()
    .shape({
      label: yup.string().trim().required(),
      value: yup.string().trim().required(),
    })
    .required(t('form_validation_errors.required_simple')),
  name: yup
    .string()
    .trim()
    .min(1, t('form_validation_errors.required_simple'))
    .required(t('form_validation_errors.required_simple')),
  color: hexColorYupField(),
});

export type ServiceClassDto = yup.InferType<typeof serviceClassSchema>;
export type ServiceClassDtoAsyncError = {
  field: keyof ServiceClassDto;
  message: string;
};

export const setServiceClassSchemaDefaultValues = (
  userStore: UserStore,
  serviceClass?: ServiceClass,
) => {
  const companyFromStore = userStore.currentCompanies[0] || userStore.user.company;
  const company = serviceClass?.company
    ? { label: serviceClass.company.legalName, value: serviceClass.company.id }
    : companyFromStore
      ? { label: companyFromStore.legalName, value: companyFromStore.id }
      : null;

  const defaultValues: ServiceClassDto = {
    company: company as AutocompleteFieldOption<CompanyBasic>,
    name: serviceClass?.name ?? '',
    color: serviceClass?.color ?? DEFAULT_PALETTE_COLOR,
  };

  return defaultValues;
};
